module.exports = __webpack_public_path__ + "img/orange-safe.ed86947d.svg";